import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  actions,
  ChooseModality,
  DeviceList,
  Email,
  Footer,
  ImprivataIdEnroll,
  ImprivataIdManual,
  ImprivataIdPush,
  Otp,
  Password,
  PasswordReset,
  Pin,
  Sms,
  SmsEnroll,
  TempCode,
  UsernamePassword,
  IcpFace,
  Username
} from '@imprivata/common-auth-ui';
import AuthError from './AuthError';

import { LoadingOverlay } from '@imprivata/nucleus';
import { postMessageToPage } from '../embed/embed';
import { withRouter } from '../utils/withRouter';

class Main extends Component {
  static propTypes = {
    startSession: PropTypes.func,
    modality: PropTypes.string,
    sessionException: PropTypes.object,
    sessionStarted: PropTypes.bool,
    startSessionEstablishing: PropTypes.bool,
    username: PropTypes.string,
    password: PropTypes.string,
    authenticationToken: PropTypes.string,
    complete: PropTypes.bool,
    accountToken: PropTypes.string,
    cloudauthEnvironment: PropTypes.string,
    isLoading: PropTypes.bool,
  };

  async componentDidMount() {
    window.addEventListener('message', this.handleFrameTasks);
    window.addEventListener('beforeunload', this.handleWindowClose);

    // Notify parent window that iframe is ready to receive messages
    // This fixes Safari race condition where onload fires before listener is attached
    if (window.parent !== window) {
      window.parent.postMessage({ type: 'IFRAME_READY', }, '*');
    }

    await this.setToken();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
    window.removeEventListener('beforeunload', this.handleWindowClose);
  }

  handleFrameTasks = (event) => {
    if (event.data.accountToken) {
      this.props.setAccountToken(event.data.accountToken, event.data.cloudauthEnvironment, event.data.selfServiceEnvironment);
    }
    if (event.data.populatedUsername) {
      this.props.setUsername(event.data.populatedUsername);
    }
    if (event.data.populatedPassword) {
      this.props.setPassword(event.data.populatedPassword);
    }
  };

  handleWindowClose = () => {
    if (this.props.session != null) {
      this.props.session.close();
    }
  };

  async componentDidUpdate(prevProps) {
    if ( (!this.props.sessionStarted && !this.props.sessionException && !this.props.startSessionEstablishing) ||
      (prevProps.accountToken !== this.props.accountToken ||
      prevProps.cloudauthEnvironment !== this.props.cloudauthEnvironment) ) {
      await this.startSession();
    }
    if (!prevProps.complete && this.props.complete) {
      postMessageToPage(this.props.username, this.props.password, this.props.authenticationToken);
    }
  }

  setToken = async () => {
    const token = this.props.router.params.token;
    const cloudauthEnvironment = this.props.router.params.cloudauthEnv;
    const selfServiceEnvironment = this.props.router.params.selfServiceEnv;
    const tokenFound = token || this.props.accountToken;

    if (tokenFound) {
      if (!this.props.accountToken && token) {
        await this.props.setAccountToken(token, cloudauthEnvironment, selfServiceEnvironment);
      }
    }
  };

  startSession = async () => {
    if (this.props.accountToken && this.props.cloudauthEnvironment && this.props.selfServiceEnvironment) {
      await this.props.startSession(this.props.accountToken, this.props.cloudauthEnvironment, this.props.selfServiceEnvironment);
    }
  };

  render() {
    if (!this.props.sessionStarted && !this.props.sessionException) {
      return (
        <LoadingOverlay showOverlay />
      );
    }
    if([
      'iid', 'sms', 'otp',
    ].includes(this.props.modality) &&
        this.props.serverState.temporaryCodeAllowed &&
        this.props.serverState.temporaryCodeAvailable &&
        !this.props.manuallyProceedToTempCode &&
        !this.props.isDeviceManagementWorkflow) {
      console.log('DEFAULT TO TEMP CODE SCREEN');
    }
    return (
      <div>
        <Routes>
          <Route path='/iid-manual' element={<ImprivataIdManual />} />
          <Route path='/iid' element={<ImprivataIdPush />} />
          <Route path='/otp' element={<Otp />} />
          <Route path='/email' element={<Email />} />
          <Route path='/password' element={<Password />} />
          <Route path='/password-reset' element={<PasswordReset />} />
          <Route path='/pin' element={<Pin />} />
          <Route path='/enrollsms' element={<SmsEnroll />} />
          <Route path='/enrollimprivataid' element={<ImprivataIdEnroll />} />
          <Route path='/sms' element={<Sms />} />
          <Route path='/choosemodality' element={<ChooseModality />} />
          <Route path='/username-password' element={<UsernamePassword />} />
          <Route path='/tempcode' element={<TempCode />} />
          <Route path='/devicelist' element={<DeviceList />} />
          <Route path='/face' element={<IcpFace />} />
          <Route path='/username' element={<Username />} />
          <Route element={<AuthError />} />
        </Routes>
        <Footer/>
        <LoadingOverlay showOverlay={this.props.isLoading}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    sessionStarted, startSessionEstablishing, modality, sessionException,
    accountToken, cloudauthEnvironment, selfServiceEnvironment, isLoading,
    username, password, authenticationToken,
    complete, serverState, manuallyProceedToTempCode, isDeviceManagementWorkflow,
  } = state.login;
  return {
    sessionStarted,
    startSessionEstablishing,
    modality,
    sessionException,
    username,
    password,
    authenticationToken,
    complete,
    accountToken,
    cloudauthEnvironment,
    selfServiceEnvironment,
    isLoading,
    serverState,
    manuallyProceedToTempCode,
    isDeviceManagementWorkflow,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startSession: (accountToken, cloudauthEnvironment, selfServiceEnvironment) => {
      dispatch(actions.startSession(accountToken, cloudauthEnvironment, selfServiceEnvironment) );
    },
    setAccountToken: (accountToken, cloudauthEnvironment, selfServiceEnvironment) => {
      dispatch(actions.setAccountToken(accountToken, cloudauthEnvironment, selfServiceEnvironment) );
    },
    setUsername: (username) => {
      dispatch(actions.setInitialUsername(username) );
    },
    setPassword: (password) => {
      dispatch(actions.setInitialPassword(password) );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Main) );
